import React from "react";
import MainImage from "../../assets/HeroImages/MainPot8.jpg";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import PastWork from "../../components/PastWord";
import About from "../../components/About";
import Testimony from "../../components/Testimony";
import { Helmet } from "react-helmet";


function LaunchGlowUp() {
  return (
    <div className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1]">
<Helmet>
  <title>Launch Glow Up Funnel & Website Kit in Dallas, TX | Woaom Web Design</title>
  <meta
    name="description"
    content="Woaom Web Design’s Launch Glow Up Kit helps women entrepreneurs, coaches, and course creators in Dallas, Texas build waitlist funnels, email lists, and brand-focused websites designed to convert."
  />
  <meta
    name="keywords"
    content="Dallas Launch Glow Up, Dallas TX launch website design, Dallas women entrepreneur launch websites, digital launch strategy Dallas TX, Dallas prelaunch funnel design, waitlist page builder Dallas, email capture website Dallas TX, sales page for launches Dallas women founders, website for product launch Dallas TX, Dallas course launch template, launch strategy for women Dallas entrepreneurs, Flodesk funnel design Dallas TX, booking flow setup Dallas websites, Dallas website for creators and coaches, Dallas TX template for new launch, product-ready website Dallas entrepreneurs, waitlist site setup Dallas, Dallas brand launch design studio, launch day website Dallas TX, pre-launch checklist site Dallas, coach launch website Dallas TX, email list builder website Dallas TX, revenue-ready platform Dallas women-owned businesses, business launch toolkit Dallas TX, digital storefront prep Dallas women entrepreneurs, launch support service Dallas TX, sales-ready website Dallas female founders, startup launch tools Dallas entrepreneurs, visual launch builder Dallas TX, high-converting launch websites Dallas women-led brands"
  />
</Helmet>


      <section className="bg-[#F7F3F2]">
        <div
          className="relative h-auto bg-cover bg-top"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
          <Navbar />
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex items-center justify-center">
              <h1 className="text-black italic text-3xl max-w-96 bg-[#CFF098] font-semibold">The Launch Glow-Up</h1>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2]">
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex flex-col items-center text-center">
              <h2 className="text-3xl font-regular md:text-5xl text-black max-w-6xl uppercase">
                Ready to Establish Your Expertise Online? Get a Website That Works as Hard as You Do.
              </h2>
              <p className="mb-8 mt-4 max-w-4xl text-base text-black md:mb-12 md:text-lg font-light">
                For ambitious <strong>women entrepreneurs</strong> ready to build a strong foundation and showcase their brilliance. Our Authority Launchpad package provides a <strong>professionally designed website</strong> to elevate your brand and credibility.
              </p>
            </div>

            {/* Benefits Grid Styled Like Services.jsx */}
            <div className="mt-12">
              <div className="grid gap-5 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:gap-4">
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">A Stunning, Up to 5-Page Website</h3>
                  <p className="text-black text-base font-light">
                    A beautiful, user-friendly website that showcases your services, tells your story, and makes it easy for potential clients to connect. Includes homepage, services, about, testimonials/case studies, and contact page.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Get Found Online with Foundational SEO</h3>
                  <p className="text-black text-base font-light">
                    We optimize your website for relevant keywords to help you rank locally and attract your ideal clients.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Seamless on Every Device</h3>
                  <p className="text-black text-base font-light">
                    Your website will be fully responsive, offering a flawless experience on mobile, tablet, and desktop.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Your Story, Beautifully Presented</h3>
                  <p className="text-black text-base font-light">
                    We help you refine or create content that speaks directly to your ideal clients and highlights your unique value.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Visually Engaging Design</h3>
                  <p className="text-black text-base font-light">
                    Access a curated library of professional, non-generic images that elevate your brand's visual identity.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Track Your Success</h3>
                  <p className="text-black text-base font-light">
                    We’ll install basic Google Analytics to help you start understanding your website performance.
                  </p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="flex flex-col items-center justify-center mt-16">
              <a href="/contact" className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black uppercase">
                SCHEDULE YOUR FREE CONSULTATION
              </a>
              <p className="text-black text-lg font-light mt-6 w-[400px] text-center">
                Empower Your Online Presence. Let's Build Your Authority Launchpad Today!
              </p>
            </div>
          </div>
        </section>
       
      
        <PastWork />
         <div className="bg-[#2E2D2B]">
<Testimony/>
         <About/>
         </div>
        <Footer />
      </section>
    </div>
  );
}

export default LaunchGlowUp;
